export enum SummaryType {
  Week = 'week',
  Weight = 'weight',
}

export interface ScenarioResult {
  currency: string;
  summaryType: SummaryType;
  maxAllowedWeight: number;
  minAllowedWeight: number;
  minAllowedWeek: number;
  maxAllowedWeek: number;
  summaries: Summary[];
  graphData: GraphData[];
}

export interface GraphData {
  feedPlan: string;
  graphValues: GraphValue[];
}

export interface GraphValue {
  productionWeek: number;
  weight: number;
}

export interface Summary {
  feedPlan: string;
  feeds: Feeds[];
  feedPlanMaxWeeks: number;
  feedPlanMaxWeight: number;
  finalWeightGrams: number;
  daysToReach: number;
  weightGainGrams: number;
  feedIntakeGrams: number;
  bFcr: number;
  carcassYieldPercent: number;
  filletFatPercent: number;
  hogGainGrams: number;
  globalWarmingPotentialCo2KgPerKgGrowth: number;
  globalWarmingPotentialCo2KgPerKgFeed: number;
  averageFeedCost: number;
  feedCostOfGrowth: number;
  feedCostOfHogGrowth: number;
  icon?: React.ReactNode;
}

export interface Feeds {
  fishSizeStart: number;
  feedId: string;
  price: number;
  feedSource: string;
  feedName: string;
  isActive: boolean;
  scenarioActive: boolean;
}
